import { getSecondsFromTimelineTime, getTimelineTimeFromTimeInput } from "../../../util/util";
import _ from 'underscore';

export namespace FetchDataHelper {
    export const getScenesData = ({ scenario, sceneId, sceneConfig, isUsedOnMobile, fromSceneEditor, isFirstTime, callback }
        : { scenario?: any; sceneId?: string; sceneConfig?: any; isUsedOnMobile?: boolean, fromSceneEditor?: boolean; isFirstTime?: boolean; callback?: (_mediasToLoad: any[]) => void })
        : { relatedSceneMedias?: any; widgetsWithTime?: any[]; sceneConfig?: any, mediasToLoad?: any[]; currentMediaId?: string; defaultSceneBGMediaId?: string } => {

        if (!scenario) {
            return {};
        }

        const scenes = scenario.scenes ?? [];
        if (scenes.length === 0) {
            return {};
        }

        let mediasToLoad: any[] = [];
        const currentSceneId = sceneId
            ? sceneId
            : !sceneConfig || !sceneConfig.currentScene
                ? scenario?.defaults?.sceneId
                : sceneConfig.currentScene;
        const currentSceneData = scenes.find((s: any) => s.id === currentSceneId);

        if (!currentSceneData) {
            return {};
        }

        const endOfScene = (currentSceneData.events ?? [])
            .find((e: any) => e.type === 'endOfScene')
            ?.actions?.find((action: any) => ['goToScene', 'loopCurrentScene', 'goToHome'].includes(action.type));
        const nextScene = endOfScene?.metadata?.sceneId ?? scenario?.defaults?.sceneId;

        // GET ALL MEDIA IN SCENE
        let layout = currentSceneData?.layouts?.find((l: any) => l.type === (isUsedOnMobile ? 'mobile' : 'desktop'));
        layout =
            layout === undefined || (layout.boxes ?? [])[0]?.widgets?.length === 0
                ? currentSceneData?.layouts?.find((l: any) => (l.boxes ?? [])[0].widgets.length > 0)
                : layout;
        const boxes = layout?.boxes ?? [];
        if (boxes.length > 0) {
            let widgets: any[] = [];
            boxes.forEach((box: any) => {
                box.widgets?.forEach((w: any) => widgets.push(w.widgetTemplateId));
            });
            currentSceneData.widgetTemplates.forEach((tmp: any) => {
                if (!widgets.includes(tmp.id)) {
                    return;
                }

                if (tmp.type === 'video' && !mediasToLoad.find((m) => m.id === tmp.settings?.mediaId && m.sceneId === currentSceneData.id)) {
                    mediasToLoad.push({
                        id: tmp.settings?.mediaId,
                        sceneId: currentSceneData.id,
                        endOfScene: endOfScene,
                    });
                }
            });
        }

        const relatedSceneMedias = {};
        let defaultSceneBGMediaId = "";
        // GET MEDIA NEXT SCENE
        if (isFirstTime) {
            const sceneToGetMedia = scenes.find((s: any) => s.id === scenario.defaults.sceneId);
            defaultSceneBGMediaId = getSceneBGMedia({
                scene: sceneToGetMedia,
                isUsedOnMobile: !!isUsedOnMobile
            }) ?? "";

            scenes.forEach((scene: any) => {
                let widgetsInBoxes: any[] = [];
                let sLayout = scene.layouts?.find((l: any) => l.type === (isUsedOnMobile ? 'mobile' : 'desktop'));
                sLayout =
                    sLayout === undefined || (sLayout.boxes ?? [])[0]?.widgets?.length === 0
                        ? scene?.layouts?.find((l: any) => (l.boxes ?? [])[0].widgets.length > 0)
                        : sLayout;
                sLayout?.boxes?.forEach((box: any) => {
                    box.widgets?.forEach((w: any) => widgetsInBoxes.push(w.widgetTemplateId));
                });

                scene.widgetTemplates.forEach((tmp: any) => {
                    const endOfScene = (scene.events ?? [])
                        .find((e: any) => e.type === 'endOfScene')
                        ?.actions?.find((action: any) => ['goToScene', 'loopCurrentScene', 'goToHome'].includes(action.type));

                    if (!widgetsInBoxes.includes(tmp.id) || tmp.type !== 'video') {
                        return;
                    }
                    if (tmp.type === 'video' && !mediasToLoad.find((m) => m.id === tmp.settings?.mediaId && m.sceneId === scene.id)) {
                        mediasToLoad.push({
                            id: tmp.settings?.mediaId,
                            sceneId: scene.id,
                            endOfScene: endOfScene,
                        });
                    }
                });

                const sceneMedia = getSceneRelatedMedias({ scene, scenario, isUsedOnMobile: !!isUsedOnMobile });
                (relatedSceneMedias as any)[scene.id] = sceneMedia;
            });
        }
        const widgetsWithTime = getSceneWidgetsWithTime({
            scene: currentSceneData,
            activeLayout: isUsedOnMobile ? 'mobile' : 'desktop',
            fromSceneEditor,
            isUsedOnMobile
        });
        const newSceneConfig = {
            currentScene: currentSceneData.id,
            nextScene: nextScene,
        };

        const mediasToLoadArray = Array.from(new Set(mediasToLoad));
        if (mediasToLoadArray.length && !fromSceneEditor) {
            callback?.(mediasToLoadArray);
        }

        return { relatedSceneMedias, widgetsWithTime, sceneConfig: newSceneConfig, mediasToLoad: mediasToLoadArray, currentMediaId: mediasToLoadArray[0].id, defaultSceneBGMediaId }
    };

    export const getSceneRelatedMedias = ({ scene, scenario, isUsedOnMobile }: { scene: any; scenario: any; isUsedOnMobile: boolean }) => {
        const scenes = scenario.scenes;
        let layout = scene?.layouts?.find((l: any) => l.type === (isUsedOnMobile ? 'mobile' : 'desktop'));
        layout =
            layout === undefined || (layout.boxes ?? [])[0]?.widgets?.length === 0
                ? scene?.layouts?.find((l: any) => (l.boxes ?? [])[0].widgets.length > 0)
                : layout;
        const boxes = layout?.boxes ?? [];
        let widgets: any[] = [];
        boxes.forEach((box: any) => {
            box.widgets?.forEach((w: any) => widgets.push(w.widgetTemplateId));
        });
        const medias: any[] = [];

        const endOfScene = (scene.events ?? [])
            .find((e: any) => e.type === 'endOfScene')
            ?.actions?.find((action: any) => ['goToScene', 'loopCurrentScene', 'goToHome'].includes(action.type));

        const widgetNextSceneId = endOfScene ? endOfScene?.metadata?.sceneId : scenario.defaults.sceneId;
        const sceneToGetMedia = scenes.find((s: any) => s.id === widgetNextSceneId);
        const sceneBGMedia = getSceneBGMedia({
            scene: sceneToGetMedia,
            isUsedOnMobile
        });
        if (sceneBGMedia && !medias.find((m) => m === sceneBGMedia)) {
            medias.push(sceneBGMedia);
        }

        scene.widgetTemplates.forEach((tmp: any) => {
            if (!widgets.includes(tmp.id)) {
                return;
            }

            let mediaId = tmp.settings?.mediaId;
            if (mediaId && !medias.find((m) => m === mediaId)) {
                medias.push(mediaId);
            } else {
                const widgetActions: any[] = [];
                (tmp.events ?? []).forEach((e: any) => {
                    const actions = (e.actions ?? []).filter((a: any) => a.type === 'goToScene' || a.type === 'goToHome');
                    if (actions) {
                        widgetActions.push(...actions);
                    }
                });

                if (widgetActions.filter(Boolean).length === 0) {
                    return;
                }

                widgetActions.filter(Boolean).forEach((action) => {
                    const widgetNextSceneId = action?.metadata?.sceneId;
                    const sceneToGetMedia = scenes.find((s: any) => s.id === widgetNextSceneId);
                    const sceneBGMedia = getSceneBGMedia({
                        scene: sceneToGetMedia,
                        isUsedOnMobile
                    });

                    if (sceneBGMedia && !medias.find((m) => m === sceneBGMedia)) {
                        medias.push(sceneBGMedia);
                    }
                });
            }
        });
        return medias;
    };

    export const getSceneBGMedia = ({ scene, isUsedOnMobile }: { scene: any; isUsedOnMobile: boolean }) => {
        if (!scene) {
            return;
        }

        let result = undefined;
        let widgetsInBoxes: any[] = [];
        let sLayout = scene?.layouts?.find((l: any) => l.type === (isUsedOnMobile ? 'mobile' : 'desktop'));
        sLayout =
            sLayout === undefined || (sLayout.boxes ?? [])[0]?.widgets?.length === 0
                ? scene?.layouts?.find((l: any) => (l.boxes ?? [])[0].widgets.length > 0)
                : sLayout;
        sLayout?.boxes?.forEach((box: any) => {
            box.widgets?.forEach((w: any) => widgetsInBoxes.push(w.widgetTemplateId));
        });

        scene?.widgetTemplates.forEach((tmp: any) => {
            if (!widgetsInBoxes.includes(tmp.id) || tmp.type !== 'video') {
                return;
            }
            if (tmp.type === 'video') {
                result = tmp.settings?.mediaId;
            }
        });

        return result;
    };

    export const getSceneWidgetsWithTime = ({ scene, activeLayout, fromSceneEditor, isUsedOnMobile }
        : { scene: any; activeLayout?: string; fromSceneEditor?: boolean; isUsedOnMobile?: boolean }
    ) => {
        let layout = scene?.layouts?.find((l: any) => l.type === (fromSceneEditor ? activeLayout : isUsedOnMobile ? 'mobile' : 'desktop'));
        layout =
            layout === undefined || (layout.boxes ?? [])[0]?.widgets?.length === 0
                ? scene?.layouts?.find((l: any) => (l.boxes ?? [])[0].widgets.length > 0)
                : layout;
        const widgetsInBoxes: any[] = [];
        layout?.boxes?.forEach((b: any) => b.widgets?.forEach((w: any) => widgetsInBoxes.push(w)));
        const widgetsWithTime: any[] = [];
        scene?.widgetTemplates?.forEach((tmp: any) => {
            if (tmp.type === 'video') {
                return;
            }
            const wInBox = widgetsInBoxes.find((w) => w.widgetTemplateId === tmp.id);
            if (wInBox) {
                widgetsWithTime.push({
                    ...wInBox,
                    end: getSecondsFromTimelineTime(getTimelineTimeFromTimeInput(wInBox.end)),
                    start: getSecondsFromTimelineTime(getTimelineTimeFromTimeInput(wInBox.start)),
                    data: tmp,
                });
            }
        });

        return widgetsWithTime;
    };

    export const getMediaData = ({ currentIndex, mediaData, id, sceneId, token, saveInteractiveElementToStore }
        : { currentIndex?: number; mediaData: any; id: string; sceneId?: string; token?: string; saveInteractiveElementToStore?: (_elems: any[]) => void }
    ) => {
        if (!mediaData || !mediaData.resources || mediaData.resources.length === 0) {
            return mediaData ?? { ...mediaData, id: id };
        }

        const mediaId = id ?? mediaData?.id;
        const { tracks } = mediaData.resources[0];
        let start = null;
        let end = null;
        if (tracks?.filter((track: any) => track.name === 'video')) {
            const videoTrack = tracks?.find((track: any) => track.name === 'video')?.sequences?.find((sequence: any) => sequence.type === 'video');
            start = videoTrack?.start;
            end = videoTrack?.end;
        }

        const originalId = mediaData?.custom?.ref?.[0] || mediaData.id;
        const videoStream = (((mediaData.resources ?? [])[0].streams ?? [])[0]?.videos ?? []).find((v: any) => v.height && v.width);

        getOnDemandInteractiveElements(tracks, saveInteractiveElementToStore);
        return {
            currentIndex: currentIndex,
            endOfScene: mediaData?.endOfScene,
            ...(mediaData?.resources[0] ?? {}),
            mediaName: (mediaData.custom ?? {})['external-title'] ?? mediaData?.title,
            description: mediaData?.description,
            isMediaRestricted: mediaData?.token === true,
            mediaDetails: mediaData?.resources,
            custom: mediaData.custom ?? {},
            playlistAsset: mediaData?.playlistAsset,
            id: mediaId,
            originalId: originalId,
            sceneId: sceneId,
            token: token,
            start,
            end,
            videoWidth: videoStream?.width ?? 0,
            videoHeight: videoStream?.height ?? 0,
        };
    };

    export const getOnDemandInteractiveElements = (tracks: any[], saveInteractiveElementToStore?: (_elems: any[]) => void) => {
        let interactiveTrack = [];
        let tempProductsArray = [];
        let tempButtonsArray = [];
        let tempImagesArray = [];
        let tempJumpToTimeArray = [];

        if (tracks !== undefined) {
            for (var i = 0; i < tracks.length; i++) {
                if (tracks[i].sequences !== undefined) {
                    for (var j = 0; j < tracks[i].sequences.length; j++) {
                        if (tracks[i].type === 'custom') {
                            if (
                                tracks[i].sequences[j].custom !== undefined &&
                                tracks[i].sequences[j].custom.interactiveWidget !== undefined &&
                                tracks[i].sequences[j].custom.interactiveWidget.template !== undefined &&
                                tracks[i].sequences[j].custom.interactiveWidget.template.id !== undefined
                            ) {
                                interactiveTrack.push(tracks[i]);
                                break;
                            }
                        }
                    }
                }
            }
        }

        if (interactiveTrack[0] !== undefined && interactiveTrack[0].sequences !== undefined) {
            tempProductsArray = interactiveTrack[0].sequences.filter(function (el: any) {
                return el.custom.interactiveWidget.template.id === 'dynamicProduct';
            });
        } else {
            tempProductsArray = [];
        }

        if (interactiveTrack[0] !== undefined && interactiveTrack[0].sequences !== undefined) {
            tempButtonsArray = interactiveTrack[0].sequences.filter(function (el: any) {
                return el.custom.interactiveWidget.template.id === '123456789TEXTBUTTON';
            });
        } else {
            tempButtonsArray = [];
        }

        if (interactiveTrack[0] !== undefined && interactiveTrack[0].sequences !== undefined) {
            tempImagesArray = interactiveTrack[0].sequences.filter(function (el: any) {
                return el.custom.interactiveWidget.template.id === 'dynamicButton12345';
            });
        } else {
            tempImagesArray = [];
        }

        if (interactiveTrack[0] !== undefined && interactiveTrack[0].sequences !== undefined) {
            tempJumpToTimeArray = interactiveTrack[0].sequences.filter(function (el: any) {
                return el.custom.interactiveWidget.template.id === '121212121';
            });
        } else {
            tempJumpToTimeArray = [];
        }

        saveListOfProducts(tempProductsArray);
        const currentProductArray = tempProductsArray.concat(tempButtonsArray.concat(tempImagesArray.concat(tempJumpToTimeArray)));
        // this.props.setCurrentInteractiveElement(currentProductArray);
        saveInteractiveElementToStore?.(currentProductArray)
    };

    export const saveListOfProducts = (products: any[], callback?: (_value: any[]) => {}) => {
        let resultArray: any[] = [];

        for (var i = 0; i < products.length; i++) {
            let tempObj = _.omit(products[i].custom.interactiveWidget.settings, 'general');
            let tempArray = Object.values(tempObj);

            resultArray.concat(tempArray);
            resultArray = [...resultArray, ...tempArray];
        }
        callback?.(resultArray);
    };

    export const rewriteUrl = (url: string) => {
        var topDomain = -1 < url.indexOf('.dna.qbrick.com')
            ? '.dna.qbrick.com'
            : -1 < url.indexOf('.dna.local')
                ? '.dna.local'
                : null;
        if (topDomain) {
            var subDomains = url.substring(2 + url.indexOf('//'), url.indexOf(topDomain));
            url = url.replace(subDomains, subDomains.replace(/\./g, '-'));
        }

        return 'file:' !== window.location.protocol
            ? url.replace(/^http[s]?:/, window.location.protocol)
            : url;
    }

    export const mapImages = (resource: any) => {
        if (resource?.collectionId) {
            return resource;
        }

        var images = [],
            l,
            r,
            rendition;

        // Find largest rendition
        for (r in resource.renditions) {
            if (!Object.prototype.hasOwnProperty.call(resource.renditions, r)) { continue; }

            rendition = resource.renditions[r];
            for (l in rendition.links) {
                if (!Object.prototype.hasOwnProperty.call(rendition.links, l)) { continue; }
                images.push({
                    rel: resource.rel,
                    collectionId: resource.id,
                    renditionId: rendition.id,
                    url: rewriteUrl(rendition.links[l].href),
                    mimeType: rendition.links[l].mimeType,
                    width: rendition.width,
                    height: rendition.height
                });
            }
        }

        return images.sort(function (a, b) {
            return b.width - a.width;
        });
    }

    export const convertToSlideSource = (images: any[]) => {
        const slideSources = images.map((img: any) => mapImages(img)).flat();
        return slideSources;
    }
}